/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Office,
    OfficeFromJSON,
    OfficeFromJSONTyped,
    OfficeToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface OfficeResponse
 */
export interface OfficeResponse {
    /**
     * 
     * @type {User}
     * @memberof OfficeResponse
     */
    user: User;
    /**
     * 
     * @type {Office}
     * @memberof OfficeResponse
     */
    office?: Office;
}

export function OfficeResponseFromJSON(json: any): OfficeResponse {
    return OfficeResponseFromJSONTyped(json, false);
}

export function OfficeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfficeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
        'office': !exists(json, 'office') ? undefined : OfficeFromJSON(json['office']),
    };
}

export function OfficeResponseToJSON(value?: OfficeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': UserToJSON(value.user),
        'office': OfficeToJSON(value.office),
    };
}


